import { ChangeDetectionStrategy, Component, ViewChild, ViewChildren } from '@angular/core';
import { DateWithTimezones, MapPoint, MapTrackingPoints } from '../../../common/models';
import { GoogleMap, MapInfoWindow, MapMarker } from '@angular/google-maps';
import { MAP_OPTIONS } from '../models/tracking-map.constants';
import { BehaviorSubject } from 'rxjs';
import { MAP_POINT_INFO_WINDOW_CONFIG, MAP_STOP_INFO_WINDOW_CONFIG } from '../constants';

@Component({
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BaseTrackingMapComponent<StopType, ConfigType> {
  @ViewChild(GoogleMap, { static: false }) mapRef: GoogleMap;

  @ViewChild('stopInfoWindow', { read: MapInfoWindow, static: false })
  stopInfoWindow: MapInfoWindow;

  @ViewChildren('stopMarkers', { read: MapMarker }) stopMarkers: MapMarker[];

  @ViewChild('pointInfoWindow', { read: MapInfoWindow, static: false })
  pointInfoWindow: MapInfoWindow;

  @ViewChildren('pointMarkers', { read: MapMarker }) pointMarkers: MapMarker[];

  mapConfig: ConfigType;
  mapTrackingPoints: MapTrackingPoints<StopType, MapPoint> = null;
  mergedPoints: MapPoint[] = [];
  mapOptions = MAP_OPTIONS;

  stopMarkerInfoContent$ = new BehaviorSubject<StopType>(null);
  pointMarkerInfoContent$ = new BehaviorSubject<DateWithTimezones>(null);

  readonly stopInfoWindowConfig = MAP_STOP_INFO_WINDOW_CONFIG;
  readonly pointInfoWindowConfig = MAP_POINT_INFO_WINDOW_CONFIG;

  stopMarkerClick(index: number, content: StopType): void {
    const marker: MapMarker = [...this.stopMarkers][index];

    this.stopMarkerInfoContent$.next(content);
    this.stopInfoWindow.open(marker);
  }

  pointMarkerClick(index: number): void {
    const point = this.mergedPoints[index];
    const pointMarker: MapMarker = [...this.pointMarkers][index];

    this.pointMarkerInfoContent$.next(point.dateTime);
    this.pointInfoWindow.open(pointMarker);
  }
}
